import { setBookMarkedLists, togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States

import {
  approve_team,
  company_details,
  end_team,
  get_category_user,
  get_create_team,
  get_create_team_lookup,
  get_create_teams,
  get_project_team,
  noapproveupdate_teams,
  reject_team,
  summary_details,
  update_teams,
  uploadapplications,
} from "helpers/backend_helper"
import {
  activitysummaryError,
  activitysummarySuccess,
  approveTeamError,
  approveTeamSuccess,
  createTeamError,
  createTeamSuccess,
  endTeamError,
  endTeamSuccess,
  getCategoryUserError,
  getCategoryUserSuccess,
  getCompanyDetailsError,
  getCompanyDetailsSuccess,
  getProjectTeamsError,
  getProjectTeamsSuccess,
  getTeamLookupError,
  getTeamLookupSuccess,
  getTeamsError,
  getTeamsSuccess,
  rejectTeamError,
  rejectTeamSuccess,
  updateteamsFail,
  updateteamsFailNoApproved,
  updateteamsSuccess,
  updateteamsSuccessNoApproved,
  uploadapplicationerror,
  uploadapplicationsuccess,
} from "./action"
import {
  APPROVE_TEAM,
  COMPANY_DETAIL,
  CREATE_TEAM,
  CREATE_TEAM_LOOKUP,
  END_TEAM,
  GET_CATEGORY_USER,
  GET_COMPANY_DETAIL,
  GET_PROJECT_TEAMS,
  GET_TEAMS,
  REJECT_TEAM,
  UPDATE_TEAMS,
  UPDATE_TEAMS_NO_APPROVED,
  UPLOAD_APPLICATION,
} from "./actionType"
import toast from "toastr"

function* getTeamLookUp() {
  try {
    // yield put(togglePageLoader(true))
    const response = yield call(get_create_team_lookup)
    if (response.statusCode === 200) {
      yield put(getTeamLookupSuccess(response))
      // yield put(togglePageLoader(false))
    } else {
      yield put(getTeamLookupError(response))
      toast.error(response?.message)
      // yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getTeamLookupError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* getTeams({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_create_teams, data)
    if (response.statusCode === 200) {
      yield put(getTeamsSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getTeamsError(response))
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getTeamsError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* createTeam({ payload: datas, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_create_team, datas)
    if (response.statusCode === 200) {
      yield put(createTeamSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(createTeamError(response))
      toast.error(response?.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(createTeamError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    callback("FAILURE")
  }
}
function* approveTeam({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(approve_team, data)
    if (response.statusCode === 200) {
      yield put(approveTeamSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(approveTeamError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(approveTeamError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* rejectTeam({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(reject_team, data)
    if (response.statusCode === 200) {
      yield put(rejectTeamSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(rejectTeamError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(rejectTeamError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* endteam({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(end_team, data)
    if (response.statusCode === 200) {
      yield put(endTeamSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(endTeamError(response))
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(endTeamError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
// update teams API Call
function* updateTeams({ payload: teams, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_teams, teams)
    if (response.statusCode === 200) {
      yield put(updateteamsSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(updateteamsFail(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(updateteamsFail(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    callback("FAILURE")
  }
}
function* companydetail({ payload: id }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(company_details, id)
    if (response.statusCode === 200) {
      yield put(getCompanyDetailsSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getCompanyDetailsError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getCompanyDetailsError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
function* activitysummary({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(summary_details, data)
    if (response.statusCode === 200) {
      yield put(activitysummarySuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
    } else {
      yield put(activitysummaryError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(activitysummaryError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* getProjectTeams({ payload: data }) {
  yield put(togglePageLoader(true))
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_project_team, data)
    yield put(togglePageLoader(true))
    if (response.statusCode === 200) {
      const filterFavouritesLists = (response?.data || []).filter(item => item?.isFavorite
      );
      yield put(getProjectTeamsSuccess(response))
      yield put(setBookMarkedLists(filterFavouritesLists))
      yield put(togglePageLoader(false))
    } else {
      yield put(getProjectTeamsError(response))
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getProjectTeamsError(error))
    // toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}
// update teams API Call not approval
function* updateTeamsnonapprove({ payload: teams, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(noapproveupdate_teams, teams)
    if (response.statusCode === 200) {
      yield put(updateteamsSuccessNoApproved(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(updateteamsFailNoApproved(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(updateteamsFailNoApproved(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}
// upload application application page
function* uploadsapplication({ payload: apps, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(uploadapplications, apps)
    if (response.statusCode === 200) {
      yield put(uploadapplicationsuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS")
    } else {
      yield put(uploadapplicationerror(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE")
    }
  } catch (error) {
    yield put(uploadapplicationerror(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}

function* categoryUsers({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_category_user, data)
    if (response.statusCode === 200) {
      yield put(getCategoryUserSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getCate(response))
      toast.error(response?.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getCategoryUserError(error))
    yield put(togglePageLoader(false))
  }
}

function* createTeamsage() {
  yield takeEvery(CREATE_TEAM_LOOKUP, getTeamLookUp)
  yield takeEvery(GET_TEAMS, getTeams)
  yield takeEvery(CREATE_TEAM, createTeam)
  yield takeEvery(APPROVE_TEAM, approveTeam)
  yield takeEvery(REJECT_TEAM, rejectTeam)
  yield takeEvery(END_TEAM, endteam)
  yield takeEvery(UPDATE_TEAMS, updateTeams)
  yield takeEvery(GET_COMPANY_DETAIL, companydetail)
  yield takeEvery(COMPANY_DETAIL, activitysummary)
  yield takeEvery(GET_PROJECT_TEAMS, getProjectTeams)
  yield takeEvery(UPDATE_TEAMS_NO_APPROVED, updateTeamsnonapprove)
  yield takeEvery(UPLOAD_APPLICATION, uploadsapplication)
  yield takeEvery(GET_CATEGORY_USER, categoryUsers)
}

export default createTeamsage
